import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { GridLayout } from '@gem/call/CallView/Shared/GridLayout/GridLayout';
import { FULL_GRID_VIEW_SIZE } from '@gem/call/CallView/constants/views';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';
import { customScrollStyles } from '@gem/ui-kit';

import styles from './FullScreenGridLayout.styles.m.css';

export const FullScreenGridLayout = observer(() => {
  const getClassName = (opponentsLength: number): string => {
    return classNames(
      styles.videoLayout,
      customScrollStyles.container,
      styles[
        `videoLayout${
          opponentsLength > FULL_GRID_VIEW_SIZE ? FULL_GRID_VIEW_SIZE : opponentsLength
        }`
      ]
    );
  };

  return (
    <GridLayout
      getClassName={getClassName}
      avatarLargeType={AvatarTypes.Round_50}
      avatarMediumType={AvatarTypes.Round_40}
    />
  );
});
